// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-16juF";
var _3 = "money-2_R3C";
var _4 = "from-3zVXo";
var _5 = "close-a1Lpn";
export { _1 as "__esModule", _2 as "container", _3 as "money", _4 as "from", _5 as "close" }
export default { "__esModule": _1, "container": _2, "money": _3, "from": _4, "close": _5 }
